module.exports = __webpack_public_path__ + "img/solitude-summer-getaway-mobile.jpg";